/**
 * @generated SignedSource<<a488b045dcce0c32c8325253a45e22fc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsPlanningProject_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_viewer">;
  readonly " $fragmentType": "TradeBenefitsPlanningProject_viewer";
};
export type TradeBenefitsPlanningProject_viewer$key = {
  readonly " $data"?: TradeBenefitsPlanningProject_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsPlanningProject_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsPlanningProject_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ae85ae804e01dfb385b088487ec427bb";

export default node;
